/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Reformulation_AfterInputs */

const en_keyword_optimizer_reformulation_after = /** @type {(inputs: Keyword_Optimizer_Reformulation_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggested`)
};

const de_keyword_optimizer_reformulation_after = /** @type {(inputs: Keyword_Optimizer_Reformulation_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschlag`)
};

const fr_keyword_optimizer_reformulation_after = /** @type {(inputs: Keyword_Optimizer_Reformulation_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggéré`)
};

const es_keyword_optimizer_reformulation_after = /** @type {(inputs: Keyword_Optimizer_Reformulation_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugerido`)
};

const it_keyword_optimizer_reformulation_after = /** @type {(inputs: Keyword_Optimizer_Reformulation_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggerito`)
};

const nl_keyword_optimizer_reformulation_after = /** @type {(inputs: Keyword_Optimizer_Reformulation_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voorgesteld`)
};

const pl_keyword_optimizer_reformulation_after = /** @type {(inputs: Keyword_Optimizer_Reformulation_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugerowane`)
};

const fi_keyword_optimizer_reformulation_after = /** @type {(inputs: Keyword_Optimizer_Reformulation_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ehdotettu`)
};

const da_keyword_optimizer_reformulation_after = /** @type {(inputs: Keyword_Optimizer_Reformulation_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foreslået`)
};

const sv_keyword_optimizer_reformulation_after = /** @type {(inputs: Keyword_Optimizer_Reformulation_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Föreslagen`)
};

/**
* | output |
* | --- |
* | "Suggested" |
*
* @param {Keyword_Optimizer_Reformulation_AfterInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_reformulation_after = /** @type {((inputs?: Keyword_Optimizer_Reformulation_AfterInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Reformulation_AfterInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_reformulation_after(inputs)
	if (locale === "fr") return fr_keyword_optimizer_reformulation_after(inputs)
	if (locale === "es") return es_keyword_optimizer_reformulation_after(inputs)
	if (locale === "it") return it_keyword_optimizer_reformulation_after(inputs)
	if (locale === "nl") return nl_keyword_optimizer_reformulation_after(inputs)
	if (locale === "pl") return pl_keyword_optimizer_reformulation_after(inputs)
	if (locale === "fi") return fi_keyword_optimizer_reformulation_after(inputs)
	if (locale === "da") return da_keyword_optimizer_reformulation_after(inputs)
	if (locale === "sv") return sv_keyword_optimizer_reformulation_after(inputs)
	return en_keyword_optimizer_reformulation_after(inputs)
});